/**
 * @generated SignedSource<<7a335ef5653fc81d00be9dd12a2af39f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContractRequestStatusEnum = "completed" | "pending" | "rejected" | "started";
export type VideoStatusEnum = "pending" | "processed" | "processing" | "processing_failed" | "processing_queued" | "processing_rejected" | "unprocessed";
export type AnswerListItem_VideoUpdatedSubscription$variables = {
  videoId?: string | null | undefined;
};
export type AnswerListItem_VideoUpdatedSubscription$data = {
  readonly videoUpdated: {
    readonly video: {
      readonly contractRequests: ReadonlyArray<{
        readonly jobApplication: {
          readonly " $fragmentSpreads": FragmentRefs<"useScreeningStepsStepper_JobApplication">;
        } | null | undefined;
        readonly status: ContractRequestStatusEnum | null | undefined;
      }> | null | undefined;
      readonly status: VideoStatusEnum;
      readonly url: string;
    } | null | undefined;
  };
};
export type AnswerListItem_VideoUpdatedSubscription = {
  response: AnswerListItem_VideoUpdatedSubscription$data;
  variables: AnswerListItem_VideoUpdatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "videoId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "videoId",
    "variableName": "videoId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnswerListItem_VideoUpdatedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VideoUpdatedPayload",
        "kind": "LinkedField",
        "name": "videoUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContractRequest",
                "kind": "LinkedField",
                "name": "contractRequests",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobApplication",
                    "kind": "LinkedField",
                    "name": "jobApplication",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "useScreeningStepsStepper_JobApplication"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnswerListItem_VideoUpdatedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VideoUpdatedPayload",
        "kind": "LinkedField",
        "name": "videoUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContractRequest",
                "kind": "LinkedField",
                "name": "contractRequests",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobApplication",
                    "kind": "LinkedField",
                    "name": "jobApplication",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContractRequest",
                        "kind": "LinkedField",
                        "name": "contractRequests",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "requestType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "timeLimitMinutes",
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectSubmission",
                            "kind": "LinkedField",
                            "name": "projectSubmission",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "submittedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isLate",
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae3b76a0ed3f2f1eadf52b6500323d5c",
    "id": null,
    "metadata": {},
    "name": "AnswerListItem_VideoUpdatedSubscription",
    "operationKind": "subscription",
    "text": "subscription AnswerListItem_VideoUpdatedSubscription(\n  $videoId: ID\n) {\n  videoUpdated(videoId: $videoId) {\n    video {\n      status\n      url\n      contractRequests {\n        status\n        jobApplication {\n          ...useScreeningStepsStepper_JobApplication\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment useScreeningStepsStepper_JobApplication on JobApplication {\n  status\n  contractRequests {\n    status\n    requestType\n    project {\n      timeLimitMinutes\n      id\n    }\n    projectSubmission {\n      startedAt\n      submittedAt\n      isLate\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4fb4f3eae22ce066ec19e9a9d6d2cd0c";

export default node;
